<template>
    <div class="">
        <div class="d-inline-block mr-2">
            <button class="btn btn-light mr-1" @click="decreaseMonth"><i class="fa fa-angle-left fa-lg" aria-hidden="true"></i></button>
            <button class="btn btn-light" @click="increaseMonth"><i class="fa fa-angle-right fa-lg" aria-hidden="true"></i></button>
        </div>
        <div class="d-inline-block">
            {{ selectedMonthName }} {{ selectedYear }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
		selectedDate: { type: Date, required: true },
    },
    computed: {
        selectedMonthName() {
            return this.months[this.selectedMonth];
        },
    },
    watch: {
        selectedDate(newValue) {
            this.selectedDay = newValue.getDate();
            this.selectedMonth = newValue.getMonth();//zero based
            this.selectedYear = newValue.getFullYear();
        },
    },
    data() {
        return {
            selectedDay: new Date().getDate(),
            selectedMonth: new Date().getMonth(),
            selectedYear: new Date().getFullYear(),
            months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        }
    },
    methods: {
        createNewDate() {
            let newDate = new Date(this.selectedYear, this.selectedMonth, this.selectedDay);

            if(newDate.getMonth() != this.selectedMonth) {
                newDate.setDate(0);
            }

            return newDate;
        },
        increaseMonth() {
            if (this.selectedMonth == 11) {
                this.selectedYear++;
                this.selectedMonth = 0;
            } else {
                this.selectedMonth += 1;
            }

            this.$emit('change', this.createNewDate());
        },
        decreaseMonth() {
            if (this.selectedMonth == 0) {
                this.selectedYear--;
                this.selectedMonth = 11;
            } else {
                this.selectedMonth -= 1;
            }

            this.$emit('change', this.createNewDate());
        },
    }
}
</script>